import { gql } from '@apollo/client'

export const Query = gql`
  query ProductCategories(
    $companyId: ID!,
    $filters: ProductCategoryFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    productCategories(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        category {
          id
          name
          color
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
